import {Injectable, ViewContainerRef, ComponentRef} from '@angular/core';
import {PopinSharedComponent} from "@shared/pop-in/popin-shared.component";
import {PopinConnexionComponent} from "@app/composant-popin/popin-connexion.component";
import {UtilisateurGP} from "@app/mon-compte/models/utilisateurGP.model";
import {ReferentielTelephone} from "@app/mon-compte/models/ReferentielTelephone.model";
import {PopinTwoChoicesSharedComponent} from "@shared/pop-in-two-choices/popin-two-choices-shared.component";
import {TranslateService} from "@ngx-translate/core";
import {
    PopinSortiDpvComponent
} from "@app/demande-permis-visite/page-demande/popin-confirmation-sorti/popin-sorti-dpv.component";

@Injectable({providedIn: 'root'})
export class PopInSharedService {

    private host!: ViewContainerRef;

    constructor(
        private translateService: TranslateService,
    ) {}

    /** Appelé UNE FOIS dans main.component.ts */
    registerHost(vcr: ViewContainerRef) {
        this.host = vcr;
    }

    popIn(message: string, button: string, title: string | null = null) {
        if (!this.host) {
            throw new Error('PopinService: host non initialisé. Appeller registerHost() dans main.component.ts');
        }

        const ref: ComponentRef<PopinSharedComponent> =
            this.host.createComponent(PopinSharedComponent);

        ref.changeDetectorRef.detectChanges();

        queueMicrotask(() => {
            ref.instance.open(message, button, title);
        });

        const promise = ref.instance.result;

        promise.finally(() => ref.destroy());

        return { result: promise as Promise<boolean> };
    }

    popInConnexion(utilisateurGP: UtilisateurGP, listeIndicatifs: ReferentielTelephone[], adresseMail: string) {
        if (!this.host) {
            throw new Error('PopinService: host non initialisé. Appeller registerHost() dans main.component.ts');
        }

        const ref: ComponentRef<PopinConnexionComponent> =
            this.host.createComponent(PopinConnexionComponent);

        ref.instance.utilisateurGP = utilisateurGP;
        ref.instance.listeIndicatifs = listeIndicatifs;
        ref.instance.adresseMail = adresseMail;

        ref.changeDetectorRef.detectChanges();

        queueMicrotask(() => {
            ref.instance.open();
        });

        const promise = ref.instance.result;

        promise.finally(() => ref.destroy());

        return { result: promise as Promise<boolean> };
    }

    popInTwoChoices(messagePopIn: string, libelleAccepter?: string, libelleRefuser?: string, titrePopIn?: string): any {
        if (!this.host) {
            throw new Error('PopinService: host non initialisé. Appeller registerHost() dans main.component.ts');
        }

        const ref: ComponentRef<PopinTwoChoicesSharedComponent> =
            this.host.createComponent(PopinTwoChoicesSharedComponent);

        ref.instance.titrePopIn = titrePopIn;
        ref.instance.messagePopIn = messagePopIn;
        ref.instance.libelleAccepter = libelleAccepter
            || this.translateService.instant('popIn.bouton.oui');
        ref.instance.libelleRefuser = libelleRefuser
            || this.translateService.instant('popIn.bouton.non');

        ref.changeDetectorRef.detectChanges();

        queueMicrotask(() => {
            ref.instance.open();
        });

        const promise = ref.instance.result;

        promise.finally(() => ref.destroy());

        return { result: promise as Promise<boolean> };
    }

    popInDPV(message: string): any {
        if (!this.host) {
            throw new Error('PopinService: host non initialisé. Appeller registerHost() dans main.component.ts');
        }

        const ref: ComponentRef<PopinSortiDpvComponent> =
            this.host.createComponent(PopinSortiDpvComponent);

        ref.instance.messagePopIn = message;

        ref.changeDetectorRef.detectChanges();

        queueMicrotask(() => {
            ref.instance.open();
        });

        const promise = ref.instance.result;

        promise.finally(() => ref.destroy());

        return { result: promise as Promise<boolean> };
    }
}
